// src/layouts/AdminLayout.jsx
import { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminBottomNav from "./AdminBottomNav";
import "./admin-layout.scss";

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar_collapsed") === "true"
  );

  const handleToggle = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem("sidebar_collapsed", next);
      return next;
    });
  };

  return (
    <div className="admin-root">
      <AdminSidebar collapsed={collapsed} onToggle={handleToggle} />

      <main className="admin-content">
        <Outlet />
      </main>

      <AdminBottomNav />
    </div>
  );
}
